export default "__VITE_ASSET__DKCfKfay__"